import React from 'react';
import Cuesheet from 'main/components/show/cuesheet/cuesheet.jsx';
import CompactCuesheet from 'main/components/show/cuesheet.compact/cuesheet.jsx';
import GlobalElementCuesheet from 'main/components/show/cuesheet.globalElement/cuesheet.jsx';
import CuesheetHeader from 'main/components/show/cuesheet/header.jsx';
import GlobalElementManagerHeader from 'main/components/show/cuesheet.globalElement/header.jsx';
import CuesheetFooter from 'main/components/show/cuesheet/footer.jsx';
import GlobalElementManagerFooter from 'main/components/show/cuesheet.globalElement/footer.jsx';
import EventViewActions from 'flux/actions/EventViewActions';
import TeamViewActions from 'flux/actions/TeamViewActions';
import EventShowListActions from 'flux/actions/EventShowListActions';
import Search from 'main/components/search/search.jsx';
import { ViewTypes } from 'shared/constants/CuesheetViews';
import AlertBarAwareContainer from 'main/components/show/cuesheet/alertBarAwareContainer';

import ActivityAuditList from 'main/components/activityAudit/list.jsx';
import ProofHistoryList from 'main/components/show/cuesheet/proofOfPerformanceHistoryList.jsx';

const showPageHoc = (ViewType = ViewTypes.Loose) => {
  const ViewTypeLookup = {
    [ViewTypes.Loose]: Cuesheet,
    [ViewTypes.Compact]: CompactCuesheet,
    [ViewTypes.GlobalElement]: GlobalElementCuesheet,
  };

  const CuesheetComponent = ViewTypeLookup[ViewType];

  return React.createClass({
    displayName: 'ShowPage',

    contextTypes: {
      router: React.PropTypes.object.isRequired,
    },
    render() {
      let isGlobalElement = ViewType === ViewTypes.GlobalElement ? true : false;
      return (
        <AlertBarAwareContainer>
          {isGlobalElement ? (
            <GlobalElementManagerHeader />
          ) : (
            <CuesheetHeader />
          )}
          <CuesheetComponent {...this.props.params} />
          <Search />
          <ActivityAuditList />
          <ProofHistoryList />
          {isGlobalElement ? (
            <GlobalElementManagerFooter />
          ) : (
            <CuesheetFooter displayTrackingElements={!isGlobalElement} />
          )}
        </AlertBarAwareContainer>
      );
    },

    componentWillMount() {
      let { teamId, eventId } = this.context.router.state.params;

      TeamViewActions.populate(teamId);
      EventViewActions.populate(teamId, eventId);
      EventShowListActions.populate(teamId, eventId);
    },
  });
};

export default showPageHoc();

export const CompactCuesheetPage = showPageHoc(ViewTypes.Compact);
export const GlobalElementCuesheetPage = showPageHoc(ViewTypes.GlobalElement);
